import React from 'react';
import { Field } from 'redux-form';
import FormField from '../../../forms/FormField';

const PromoCodeFormSection = ({
  promoCodeValue,
  handlePromoCodeSubmit,
  handlePromoCodeDelete,
  cartPromoCode,
  promoCodeResult,
  delPromoCodeResult
}) => {

  const promoCodeApplied = !!cartPromoCode

  const {
    inProgress: promoCodeInProgress
  } = promoCodeResult || {};

  const {
    inProgress: delPromoCodeInProgress
  } = delPromoCodeResult || {};

  const inProgress = promoCodeInProgress || delPromoCodeInProgress;

  return (
    <section className="form-bit">
      <h3 className="column-header">Promo Code</h3>
      {!promoCodeApplied && (
        <div className="form-row">
          <div className="col-md-4">
            <Field
              name="promoCode"
              type="text"
              component={FormField.Input}
              placeholder="Enter Code"
              disabled={promoCodeApplied || inProgress}
            />
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-inverse btn-block"
                disabled={promoCodeApplied || inProgress || !promoCodeValue}
                onClick={handlePromoCodeSubmit}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}
      {promoCodeApplied && (
        <div className="form-row">
          <div className="col-md-4">
            {cartPromoCode}
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-inverse btn-block"
                onClick={handlePromoCodeDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

export default PromoCodeFormSection;